export default () => {
    
	/*-------- Drop down --------*/
	if ($(".block-listdrop").length) {
		$('.title').click(function () {
			var $elem = $(this).closest('.elem');
			var $content = $elem.find('.content');
	
			// Ferme tous les autres volets
			$('.elem').not($elem).removeClass('active').find('.content').slideUp();
	
			// Bascule l'état actif sur l'élément actuel
			$elem.toggleClass('active');
			$content.stop().slideToggle(); // Utilise slideToggle pour une hauteur dynamique
		});
	}
    
}